<template>
  <md-modal-dialog
    class="md-dialog multicity-dialog"
    @md-opened="event = 'md-opened'"
    v-slot="{availableTrips, img, onDatesReady}"
  >
    <button class="close-btn" @click="onClose">
      <RemoveIcon class="remove-icon" />
    </button>

    <ModalWrapper class="modal-content" :boxStyles="box">
      <SelectDates
        :tripsToSchedule="availableTrips"
        :img="img"
        @dates-selected="onDatesSelected"
        :onDatesSelected="onDatesReady"
      />
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import Vue from 'vue';
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import RemoveIcon from '../../svg/remove-thin.vue';
import SelectDates from './select-dates.vue';
Vue.use(VueCompositionAPI);

export default defineComponent({
  name: 'multi-city-dialog',
  components: {
    ModalWrapper,
    SelectDates,
    RemoveIcon,
  },
  methods: {
    onClose() {
      this.$modal.submit();
    },
    onDatesSelected(dates) {
      this.$modal.submit(dates);
    },
  },
  setup() {
    // const step = ref(0);
    // const availableTrip = ref(null);
    // const onTripSelected = ({tripToSchedule, savedTrip}) => {
    //   availableTrip.value = savedTrip;
    //   step.value += 1;
    // };

    return {
      box: {flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column'},
      // onTripSelected,
      // step,
      // availableTrip,
    };
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
  --max-dialog-width: 550px;
}

.modal-content {
  height: auto;
  flex: 1;
  overflow: hidden;
  align-items: flex-start;
  flex-direction: column;
}

.close-btn {
  position: absolute;
  right: 0;
  border-radius: 50%;
  outline: none;
  padding: 10px;
  border: none;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  border-radius: 0 0px 0 10px;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  color: #000;
  z-index: 1002;
}
</style>

<style>
.md-dialog-container.md-theme-default {
  width: 100%;
  border-radius: 20px;
}

.multicity-dialog > * {
  overflow: hidden !important;
  display: flex;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
</style>
